<template>
  <section class="section section--features">
    <div class="r">
      <header>
        <h3 class="h-1">{{ __TT('feature-component-header') }}</h3>
        <ul class="features-list">
          <li
            v-for="feature in features"
            :key="feature.id"
            class="features-item h-3"
            :class="feature.class"
          >
            <span class="icon icon--chathams-blue" :class="feature.icon" aria-hidden="true"></span>
            {{ __TT(feature.name) }}
          </li>
        </ul>
      </header>

      <div
        v-for="feature in features"
        :key="feature.id"
        class="feature"
        :class="[
          `feature--${feature.id}`,
          {
            active: activeFeature === feature.id,
            [`bg-${feature.id}`]: activeFeature === feature.id,
            inactive: activeFeature !== feature.id,
          },
        ]"
      >
        <div class="feature__image" :class="{ active: activeFeature === feature.id }">
          <img
            class="lazy"
            :src="`${feature.image}?width=288`"
            :srcset="feature.imageSet"
            :sizes="imageSizes"
            width="288"
            height="177"
            :alt="feature.alt"
          />
        </div>

        <div class="feature__details">
          <h3 class="feature__title h-3">
            <span class="icon" :class="[feature.iconColor, feature.icon]" aria-hidden="true"></span>
            {{ __TT(feature.name) }}
          </h3>
          <h4 class="feature__subtitle h-2">{{ __TT(feature.subtitle) }}</h4>
          <p class="feature__description p-2">{{ __TT(feature.description) }}</p>

          <div class="feature__statistic">
            <h3 class="feature__statistic--number h-1">
              {{ feature.statValue }} <span class="p-1">{{ __TT(feature.statText) }}</span>
            </h3>
            <h4 class="feature__statistic--text h-5">
              {{ __TT(feature.statDesc) }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      activeFeature: '',
      features: [
        {
          id: 'event',
          name: 'Events',
          class: 'feature__events',
          icon: 'icon-calendar',
          iconColor: 'icon--parsley',
          image: 'https://assets.trualta.com/events-page-screenshot.png',
          alt: 'screenshot of a support group',
          subtitle: 'feature-component-subtitle-events',
          description: 'feature-component-description-events',
          statValue: '4.8/5',
          statText: 'stars',
          statDesc: 'feature-component-statistic-events',
          imageSet: `
            https://assets.trualta.com/events-page-screenshot.png?format=webp&width=500 500w,
            https://assets.trualta.com/events-page-screenshot.png?format=webp&width=1000 1000w,
            https://assets.trualta.com/events-page-screenshot.png?format=webp&width=1500 1500w
          `,
        },
        {
          id: 'learning',
          name: 'Learning',
          class: 'feature__learning',
          icon: 'icon-learning',
          iconColor: 'icon--dark-lilac',
          image: 'https://assets.trualta.com/learning-library-screenshot.png',
          alt: 'screenshot of the learning library',
          subtitle: 'feature-component-subtitle-learning',
          description: 'feature-component-description-learning',
          statValue: '90%',
          statText: '',
          statDesc: 'feature-component-statistic-learning',
          imageSet: `
            https://assets.trualta.com/learning-library-screenshot.png?format=webp&width=500 500w,
            https://assets.trualta.com/learning-library-screenshot.png?format=webp&width=1000 1000w,
            https://assets.trualta.com/learning-library-screenshot.png?format=webp&width=1500 1500w
          `,
        },
        {
          id: 'forum',
          name: 'Forum',
          class: 'feature__forum',
          icon: 'icon-speech-bubbles',
          iconColor: 'icon--chathams-blue',
          image: 'https://assets.trualta.com/forum-screenshot.png',
          alt: 'screenshot of the forum',
          subtitle: 'feature-component-subtitle-forum',
          description: 'feature-component-description-forum',
          statValue: '92%',
          statText: '',
          statDesc: 'feature-component-statistic-forum',
          imageSet: `
            https://assets.trualta.com/forum-screenshot.png?format=webp&width=500 500w,
            https://assets.trualta.com/forum-screenshot.png?format=webp&width=1000 1000w,
            https://assets.trualta.com/forum-screenshot.png?format=webp&width=1500 1500w
          `,
        },
      ],
      imageSizes: `
        (max-width: 480px) 448px,
        (max-width: 768px) 413px,
        (max-width: 1024px) 469px
      `,
    };
  },
  methods: {
    scrollHandler() {
      let sections = document.getElementsByClassName('feature');
      let viewportMiddle = window.innerHeight / 2;
      let closestSection = null;
      let closestDistance = Infinity;

      for (let section of sections) {
        let rect = section.getBoundingClientRect();
        let sectionMiddle = rect.top + rect.height / 2;
        let distance = Math.abs(viewportMiddle - sectionMiddle);

        if (rect.top >= window.innerHeight || rect.bottom <= 0) continue;

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = section;
        }
      }

      if (closestSection) {
        this.activeFeature =
          this.features.find((f) => closestSection.classList.contains(`feature--${f.id}`))?.id ||
          '';
      } else {
        this.activeFeature = '';
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
    this.scrollHandler();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
};
</script>
